import 'css-chunksrc/client/scenes/projectCreationForm/tagList/styles.scss';export default {
  "tagList": "_tagList_x8ice_1",
  "list": "_list_x8ice_9",
  "buttonWrapper": "_buttonWrapper_x8ice_18"
};